import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as PoliciesActions from '@src/redux/actions/policies.actions'
import { createSelector } from 'reselect'
import type { State } from '@src/redux/configureStore'
import { find } from 'lodash'
import ResizableViewer, { Format } from '../../../resizable.viewer'
import { CSSSelector } from '@src/utils/css.selector.helper'
import { getIdFromUri, skipPath } from '@src/utils/url.utils'
import { useLocation } from 'react-router-dom'

const getPolicyList = (state: State) => state.policies.policyList || []
const getSelectedPolicy = (state: State) => state.policies.selectedPolicy

const getPolicyDocumentSelector = createSelector(
  [getPolicyList, getSelectedPolicy],
  (policyList, selectedPolicy) =>
    (find(policyList, item => item.policy_name === selectedPolicy) || {})
      .policy_document || ''
)

export interface Props {}

export const CSSSelectors = {
  policyJsonViewerSelector: new CSSSelector('policyJsonViewer')
}

const PolicyJsonContainer: React.FC<Props> = React.memo((props: Props) => {
  const dispatch = useDispatch()
  const resizableViewerRef = React.useRef<HTMLDivElement>()
  const location = useLocation()
  const selectedPolicy = useSelector(
    (state: State) => state.policies.selectedPolicy
  )
  const policyDocument = useSelector(getPolicyDocumentSelector)
  const loading = useSelector((state: State) => state.policies.isPending)

  React.useEffect(
    () => () => {
      onCloseViewer()
    },
    []
  )
  React.useEffect(
    () => () => {
      if (resizableViewerRef.current) {
        resizableViewerRef.current = null
        onCloseViewer()
      }
    },
    [location]
  )

  function onCloseViewer() {
    dispatch(PoliciesActions.setSelectedPolicy(null, [], null))
  }

  const displayPolicy = getIdFromUri(selectedPolicy) || skipPath(selectedPolicy)

  return selectedPolicy ? (
    <ResizableViewer
      ref={resizableViewerRef}
      id={CSSSelectors.policyJsonViewerSelector.value}
      format={Format.json}
      data={policyDocument}
      loading={loading}
      title={displayPolicy}
      onCloseViewer={onCloseViewer}
    />
  ) : null
})

export default PolicyJsonContainer
